import generalInformationNav from "./navigations/generalInformation";
import projectSchedulesNav from "./navigations/ProjectSchedules";
import ProjectFinancingNav from "./navigations/ProjectFinancing";
import MiscellaneousNav from "./navigations/Miscellaneous";
import SubmitNav from "./navigations/Submit";
import MainLayout from "../Layouts/Main/main";
import { programTypes } from "../Constants";

const siteMap = [
  {
    text: "General Information",
    route: "/generalinformation",
    navigation: generalInformationNav("/generalinformation"),
    layout: MainLayout,
    programs: [],
  },
  {
    text: "Budget",
    status: 2,
    route: "/projectfinancing",
    navigation: ProjectFinancingNav("/projectfinancing"),
    layout: MainLayout,
    programs: [],
  },
  {
    text: "Project Schedules",
    route: "/projectschedules",
    navigation: projectSchedulesNav("/projectschedules"),
    layout: MainLayout,
    programs: [programTypes.regularProgram, programTypes.CollaborativeTrack],
  },
  {
    text: "Miscellaneous",
    status: 1,
    route: "/miscellaneous",
    navigation: MiscellaneousNav("/miscellaneous"),
    layout: MainLayout,
    programs: [],
  },
  {
    text: "Submit",
    status: 1,
    route: "/submit",
    navigation: SubmitNav("/submit"),
    layout: MainLayout,
    programs: [],
  },
];

const routingOrder = (programtype, preProposal) => {
  const map = preProposal
    ? siteMap
        .filter(
          (sm) =>
            sm.programs === null ||
            sm.programs.length === 0 ||
            sm.programs.includes(programtype)
        )
        .flatMap((sm) => sm.navigation)
        .flatMap((n) => n.links)
        .filter((link) => link.stage === "preProposal")
        .map((l) => l.route)
        .filter((r) => r)
    : siteMap
        .filter(
          (sm) =>
            sm.programs === null ||
            sm.programs.length === 0 ||
            sm.programs.includes(programtype)
        )
        .flatMap((sm) => sm.navigation)
        .flatMap((n) => n.links)
        .map((l) => l.route)
        .filter((r) => r);
  return map;
};

export function getPrev(current, programtype, preProposal) {
  const order = routingOrder(programtype, preProposal);
  const index = order.indexOf(current);
  if (index === -1) return null;
  if (!order[index - 1]) return null;
  return order[index - 1];
}

export function getNext(current, programtype, preProposal) {
  const order = routingOrder(programtype, preProposal);
  const index = order.indexOf(current);
  if (index === -1) return null;
  if (!order[index + 1]) return null;
  return order[index + 1];
}

export function hasPrev(current, programtype, preProposal) {
  const order = routingOrder(programtype, preProposal);
  const index = order.indexOf(current);
  if (index === -1) return false;
  if (!order[index - 1]) return false;
  return true;
}

export function hasNext(current, programtype, preProposal) {
  const order = routingOrder(programtype, preProposal);
  const index = order.indexOf(current);
  if (index === -1) return false;
  if (!order[index + 1]) return false;
  return true;
}
